// Guarantees pressing Enter in any search input navigates to the search
// results page — same as clicking the search icon — even if the theme's
// predictive-search keyup handler swallows the event first.
(function () {
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;

    var input = e.target;
    if (!input || !input.classList || !input.classList.contains('search__input')) return;

    var query = input.value.trim();
    if (!query) return;

    // If the user has arrow-keyed to a predictive suggestion, let the
    // theme's own selectOption() handle it instead of hijacking Enter.
    var host = input.closest('predictive-search') || input.closest('form');
    var selected = host && host.querySelector('[aria-selected="true"] a, button[aria-selected="true"]');
    if (selected) return;

    e.preventDefault();
    e.stopImmediatePropagation();

    var form = input.closest('form');
    var searchUrl = (form && form.getAttribute('action')) ||
      (window.routes && window.routes.search_url) ||
      '/search';

    window.location.href = searchUrl + '?q=' + encodeURIComponent(query) + '&type=product';
  }, true); // capture phase, so it runs before the theme's own keyup logic
})();
